import { render, staticRenderFns } from "./TransactionClassificationRuleDialog.vue?vue&type=template&id=45c92afb&scoped=true"
import script from "./TransactionClassificationRuleDialog.vue?vue&type=script&lang=ts"
export * from "./TransactionClassificationRuleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c92afb",
  null
  
)

export default component.exports